import { ListLoader } from "@/loaders";

export default {
  feed: new ListLoader("/system-events-feed/", {
    defaultParams: { page_size: 25 },
    isSingleRequest: false,
  }),
  codes: new ListLoader("/followups/system_event_codes/", {
    setter: "systemEvents/setSystemEventCodes",
  }),
};
